const licensedStates = [
  "AL",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "FL",
  "GA",
  "IA",
  "ID",
  "IL",
  "KS",
  "MD",
  "ME",
  "MI",
  "NC",
  "NE",
  "NJ",
  "OH",
  "OR",
  "PA",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "WA",
  "WI",
  "WY",
];

export default licensedStates;
